<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col>
        <b-card :title="$t('users.general')">
          <fields group="general" />
        </b-card>
        <b-card
          v-if="$allows('users.update')"
          :title="$t('users.notifications')"
        >
          <fields group="notifications" />
        </b-card>
      </b-col>
      <b-col>
        <b-card :title="$t('users.billing_info')">
          <fields group="billing" />
        </b-card>
        <b-card v-if="$allows('users.update')" :title="$t('users.password')">
          <fields group="password" />
        </b-card>
        <b-card :title="$t('users.payment')">
          <b-form-group
            v-if="model.card_brand"
            :label="$t('users.credit_card')"
            label-for="credit-card"
            label-cols="4"
          >
            <b-form-input
              :value="`${model.card_brand}: **** **** **** ${model.card_last_four}`"
              type="text"
              class="form-control-plaintext"
            />
          </b-form-group>
          <div v-else>{{ $t('users.no_payment_info') }}</div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card
          v-if="$allows('users.affiliates')"
          :title="$t('users.affiliation')"
        >
          <fields group="affiliate" />
        </b-card>
      </b-col>
      <b-col />
    </b-row>
    <b-row>
      <b-col>
        <b-card
          v-if="$allows('users.partners')"
          :title="$t('users.partnership')"
        >

          <div class="form-group row">
            <div class="col-sm-8 offset-sm-4">
              <div class="form-check">
                <input
                  id="partner"
                  v-model="model.partner"
                  type="checkbox"
                  :value="model.partner"
                  class="form-check-input"
                  @change="setPartnerCommission()"
                />
                <label for="partner">
                  {{ $t('users.make_this_user_partner') }}
                </label>
              </div>
            </div>
          </div>

          <fields group="partner" />
        </b-card>
      </b-col>
      <b-col />
    </b-row>
    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import UsersApi from './UsersApi'

export default {
  name: 'UsersForm',

  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'users',
    }
  },

  mounted() {
    this.loadForm().then(() => {
      this.setFieldGroup('general', [
        'appeal',
        'first_name',
        'last_name',
        'company_name',
        'currency',
        'email',
        'avatar_id',
        'gender',
        'language',
        'settings.phone',
        'settings.email_2',
        'settings.phone_2',
      ])

      this.setFieldGroup('affiliate', [
        'affiliate',
        'affiliate_commission',
        'permissions.change affiliate commission',
        'auto_billing',
        'deferred_payments',
        'admin_billing_id',
      ])
      this.setFieldGroup('partner', [
        'partner_commission',
        'permissions.change partner commission',
      ])
      this.setFieldGroup('password', ['password'])
    })
  },

  methods: {
    api() {
      return new UsersApi()
    },

    submit() {
      this.save().then(() => {
        this.$toast.success('User was saved successfully')
      })
    },
    setPartnerCommission() {
      if(this.model.partner) {
        this.model.partner_commission = this.$settings.default_partner_commission
      } else {
        this.model.partner_commission = null;
      }
    }
  },
}
</script>
